import React, { Component } from "react";
import {
	View,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Alert,
	Platform,
	Image,
	TouchableOpacity,
	Linking,
	Switch,
} from "react-native";
import { NavigationActions } from "react-navigation";
import { translate } from "react-i18next";
import range from "lodash.range";
import { get, post } from "api";
import {
	ControlPanelIP,
	ControlPanelPostIP,
	MODE,
	AWS as AWSConfig,
	AppURL,
} from "utils/config";

import AWS from "aws-sdk/dist/aws-sdk-react-native";

import { push, reset } from "utils/navigation";
import { signUp, login, refresh } from "utils/awsAuth";
import { TextField } from "components/third-party/Textfield";
import ViewScroll from "components/ViewScroll";
import BackgroundImage from "components/BackgroundImage";
import Text from "components/StyledText";
import Checkbox from "components/Checkbox";
import Header from "components/Header";
import Button from "components/Button";
import Textfield from "components/Textfield";
import Select from "components/Select";

import * as x from "../../styles/css";

class Timer extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;

	constructor(props) {
		super(props);

		this.state = {
			deviceId: "",
			inputs: {
				timer: '',

			},
			loading: false,
		};
	}

	componentDidUpdate(prevProps, prevState) {
	}

	componentDidMount() {
		console.log("Timer Page - component did mount")
		let userData = [];
		if(Platform.OS !== "web"){
			// should load using react-native memory
		} else {
			// load from localStorage
			let shadowDetails = JSON.parse(localStorage.getItem("shadowDetails"));
			console.log("Timer - shadowDetails retrieved. ", shadowDetails);

			this.setState({
				deviceId: localStorage.getItem("deviceId").replace(/"/g,''),
				inputs: {
					timer: shadowDetails.timer, // ? shadowDetails.Timer : "0",

				},
			},
		() => console.log("Timer - this.state.inputs ", this.state.inputs));
		}
	}

	handleSave = () => {
			// update to AWS things!
			this.perform(this.state.inputs);
	}

	perform = (inputs) => {
		const body = {
			timer: inputs.timer,
		};

		this.setState({
			loading: true,
		})
		console.log("Timer - Posting update",((`${ControlPanelPostIP}/${this.state.deviceId}`, body)))
		post(`${ControlPanelPostIP}/${this.state.deviceId}`, body)
			.then(res=> {
				this.setState({
					loading: false,
				},() => {
					// redirect if success
					push({ mobile: "Home", web: "/" }, this.props, true);
				});
			})
			.catch(err => {
				if (err.message == "Failed to fetch") {
					console.error(err);
					return;
				}

				if (err.status === 403 || err.status === 503) {
					console.log("4/503 Refresh Requested");
					refresh()
						.then(res => {
							console.log("Refresh Response : ", res);
							this.initDevice();
							return;
						})
						.catch(err => {
							console.error(err.message);
							this.logout();
						});
				}
				// err.json().then(res => {
					// if (res.message === "Unauthorized") {
					// 	refresh()
					// 		.then(resp => {
					// 			this.perform();
					// 			return;
					// 		})
					// 		.catch(err => {
					// 			console.log(err);
					// 			this.logout();
					// 		});
					// }
					// if (res.message === "Identity token has expired") {
					// 	refresh()
					// 		.then(resp => {
					// 			this.perform();
					// 			return;
					// 		})
					// 		.catch(err => {
					// 			console.log(err);
					// 			this.logout();
					// 		});
					// }
				 // });
				this.setState({
					loading: false,
				});
			});
	}

	render() {
		const { inputs } = this.state;
		console.log("Render ", inputs);

		const { t } = this.props;

		return (
			<ViewScroll>
				<View style={[x.mb.three]}>
					<Header>{t("labels.timer")}</Header>
				</View>
				<View style={[x.my.three]}>

						<View style={[x.my.one]}>
							<Select
								native
								label={t("labels.timer")}
								data={range(1,24)}
								value={inputs.timer}
								onChange={element =>
									this.setState({
										inputs: { ...inputs, timer: element.target.value },
									})
								}
							/>
						</View>
					<View style={[x.mt.one]}>
						<Button
							disabled={this.state.loading}
							title={t("labels.save")}
							color={x.colors.default}
							onPress={this.handleSave}
						/>
					</View>
				</View>
			</ViewScroll>
		);
	}
}

export default translate()(Timer);



// WEBPACK FOOTER //
// ./src/views/Timer/index.js